import React from 'react'
import { Flex, Box } from '@chakra-ui/react';

const AboutKR = ({ content }) => {
    return (
        <Box>
            {content}
        </Box>
    )
}

export default AboutKR